'use client';
import './JobBoard.css';
import { SideAds } from '../../components/Ads/Ads';
import FrequentTags from './Components/FrequentTags';
import JobCard from './Components/JobCard';
import JobSearchBar from './Components/JobSearchBar';
import { useState, useEffect } from 'react';
import { useMemo } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Filterbtn from './Components/Filterbtn';
import FilterPanel from './Components/FilterPanel';
import jobApi from '../../services/jobApi';
import Pagination from '../../components/Pagination/Pagination';
import JobCardPlaceholder from '../../components/Placeholder/JobCardPlaceholder';
import useDebounce from '../../Hooks/useDebounce';
import { IoIosInformationCircle } from "react-icons/io";
import JobInfoModel from './Components/JobInfoModel';
import strings from "../../config/App.json";
import modalStrings from "../../config/modalStrings.json";
import '../blogs/[category]/Blogs.css';
import '../einbuergerungstest/ToolDetailsPage.css';
import '../einbuergerungstest/mocktest/bavaria/MockTest.css';
import '../einbuergerungstest/mocktest/bavaria/StateSelection.css';
import ModalBox from '@/components/popupmodel/ModalBox';
import { JobSideAds } from '@/components/Ads/jobAds';
import AdSlot from '@/components/Ads/components/AdSlot';

export default function JobBoard() {
  const [jobs, setJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [totalJobs, setTotalJobs] = useState(0);
  const [showFilters, setShowFilters] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState({
    jobCategory: [],
    timeframe: "All Time",
    city: "All",
    search: "",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 400);
  const [openModalType, setOpenModalType] = useState(null);

  const handleModalStateChange = (type, isOpen) => {
    setOpenModalType(isOpen ? type : null);
  };
  const toggleFilters = () => setShowFilters(!showFilters);

  const handleSearchSubmit = (term) => {
    setFilters((prev) => ({ ...prev, search: term }));
    setCurrentPage(1);
  };

  const handleTagClick = (tag) => {
    setFilters((prev) => {
      if (prev.jobCategory.includes(tag)) {
        return {
          ...prev,
          jobCategory: prev.jobCategory.filter((t) => t !== tag),
        };
      } else {
        return {
          ...prev,
          jobCategory: [...prev.jobCategory, tag],
        };
      }
    });

    setSearchTerm("");
    setCurrentPage(1);
  };


  useEffect(() => {
    setFilters((prev) => ({ ...prev, search: debouncedSearch }));
    setCurrentPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filters.jobCategory, filters.timeframe, filters.city, filters.search]);

  const jobQuery = useMemo(() => {
    const params = { page: currentPage, limit: jobsPerPage };

    const search = (filters.search || "").trim();
    if (search) params.search = search;

    if (filters.jobCategory && filters.jobCategory.length > 0) {
      params.jobCategory = filters.jobCategory.join(",");
    }

    if (filters.timeframe && filters.timeframe.toLowerCase() !== "all time") {
      params.timeframe = filters.timeframe;
    }

    if (filters.city && filters.city.toLowerCase() !== "all") {
      params.city = filters.city;
    }

    return params;
  }, [
    currentPage,
    filters.search,
    filters.timeframe,
    filters.city,
    filters.jobCategory,
  ]);

  const jobQueryKey = useMemo(() => JSON.stringify(jobQuery), [jobQuery]);

  useEffect(() => {
    let mounted = true;

    const fetchJobs = async () => {
      try {
        setLoading(true);
        const response = await jobApi.getJobs(jobQuery);

        if (!mounted) return;
        if (response.data) {
          setJobs(response.data.jobs);
          setTotalPages(response.data.pagination.totalPages);
          setTotalJobs(response.data.pagination.total);
        }
      } catch (error) {
        if (!mounted) return;
        console.error("Error fetching jobs:", error);
        setJobs([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchJobs();
    return () => {
      mounted = false;
    };
  }, [jobQueryKey]);

  useEffect(() => {
    const storedTags = localStorage.getItem("jobTags");

    if (storedTags) {
      setTags(JSON.parse(storedTags));
    } else {
      const fetchTags = async () => {
        try {
          const response = await jobApi.getTags();
          if (response.data) {
            setTags(response.data.tags || []);
            localStorage.setItem("jobTags", JSON.stringify(response.data.tags || []));
          }
        } catch (error) {
          console.error("Error fetching tags:", error);
          setTags([]);
        }
      };

      fetchTags();
    }
  }, []);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Header />
      <div className="job-content" style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="background-ellipses">
          <div className="ellipse ellipse-1"></div>
          <div className="ellipse ellipse-2"></div>
        </div>

        <div className="page-container">
          <div className='job-header-container'>
            <div className='job-header-texts'>
              <h1 className="Job_title">Discover your dream job</h1>
              <p className="Job_des">Browse and discover your next opportunity in Bavaria</p>
            </div>
            <button
              className="apply-btn"
              id='postJobBtn'
              onClick={() => window.location.href = strings.PostJobPage}
            >
              <img src='/images/Job/add.svg' alt="Add" className="addIcon" />
              <span className="locationIcon">Post a Job</span>
            </button>
          </div>

          <div className="searchFlex" id='searchFlex'>
            <div className="searchBar" id='searchBar'>
              <JobSearchBar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                tags={tags}
                onSearchSubmit={handleSearchSubmit}
              />
            </div>
          </div>
          <div className='job-inf-container'>
            <span className='job-inf' onClick={openModal}><IoIosInformationCircle size={20} color='rgba(141, 141, 153, 1)' /> Important information on the job listings</span>
          </div>

          <div className="filter-container">
            {filters.search ? (
              <div className="Search-results" id="search_results">
                Showing results for
                <span className="text-style-2"> {filters.search}</span> <br />
                <span className="Search-results-count">
                  {loading ? "..." : totalJobs || 0} results found
                </span>
              </div>
            ) : (
              <FrequentTags tags={tags} onTagClick={handleTagClick} filters={filters} />
            )}
            <Filterbtn toggleFilters={toggleFilters} showFilters={showFilters} />
          </div>

          {showFilters && (
            <FilterPanel filters={filters} setFilters={setFilters} tags={tags} totalJobs={totalJobs} />
          )}

          <div className="content-container_wrapper">
            <div className="content-container">
              {loading ? (
                Array.from({ length: 3 }).map((_, i) => <JobCardPlaceholder key={i} />)
              ) : jobs.length > 0 ? (
                jobs.map((job, index) => (
                  <div key={job.id || index}>
                    <JobCard
                      company={job.company_name}
                      title={job.title}
                      description={job.description}
                      location={job.city || job.locations?.join(", ")}
                      timePosted={job.created_at_api}
                      logo={job.logo}
                      applylink={job.link}
                    />

                    {index === 4 && (
                      <AdSlot
                        slotKey="jobs_inline_bottom_ad"
                        containerClass="jobs_inline_bottom_ad"
                        className="jobs_inline_bottom_ad_image"
                        id="jobs_inline_bottom_ad"
                      />
                    )}
                  </div>
                ))
              ) : (
                <p>No jobs found.</p>
              )}

              <div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </div>
            </div>

            <div className="tools-advertisement">
              <JobSideAds />
              <br />
              <SideAds />
            </div>
          </div>
        </div>
      </div>
      <JobInfoModel isOpen={modalIsOpen} onRequestClose={closeModal} />
      <Footer />
      <ModalBox
        type="jobs"
        noOfTimesToShow={2}
        title={modalStrings.jobs.title}
        text={modalStrings.jobs.text}
        buttonText={modalStrings.jobs.buttonText}
        showOnEveryRefresh={true}
        showInput={true}
        autoShowDelay={3000}
        isAnyModalOpen={openModalType !== null}
        onModalStateChange={handleModalStateChange} />

    </>
  );
}
